export default __webpack_public_path__ + "static/instagram-166bf3a087dc62611e23d2ab794b923a.svg";